import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonContent, useIonViewWillEnter, createAnimation } from '@ionic/react'
import { MktButton, UseHeader, VerifyCodeInput, TipModal } from '@cps'
import { modalLayer, toast } from '@utils'
import { memberMobx } from '@mobxStore'
import i18n from 'i18next'
import './index.scss'

// interface
interface IProps {
  codeType: string;
  type: string;
  account: string;
  countryCode: string;
  reject?: () => void;
  resolve?: () => void;
}

const verifyCodeBind = memberMobx.verifyCodeTypes.binding
const verifyCodeMerge = memberMobx.verifyCodeTypes.merge
const verifyCodeRegister = memberMobx.verifyCodeTypes.register

const Verify: FC<IProps> = (props: IProps) => {
  const {
    codeType,
    type,
    account,
    countryCode,
    reject,
    resolve,
  } = props
  const enterAnimation = (baseEl: any) => {
    const backdropAnimation = createAnimation()
      .addElement(baseEl.querySelector('ion-backdrop'))
      .fromTo('opacity', '0.01', 'var(--backdrop-opacity)')
    const wrapperAnimation = createAnimation()
      .addElement(baseEl.querySelector('.modal-wrapper'))
      .duration(150)
      .keyframes([
        { offset: 0, opacity: '0', transform: 'translateX(50%)' },
        { offset: 1, opacity: '1', transform: 'translateX(0)' },
      ])
    return createAnimation()
      .addElement(baseEl)
      .easing('ease-out')
      .duration(150)
      .addAnimation([backdropAnimation, wrapperAnimation])
  }
  const leaveAnimation = (baseEl: any) => {
    return enterAnimation(baseEl).direction('reverse')
  }
  const [verifyCodeInfo, setVerifyCodeInfo] = useState<any>({})
  // Data Method
  // Component Event
  let posting = false
  const handleFinish = () => {
    if (!verifyCodeInfo.inputValue) {
      toast({ message: i18n.t('mkt.common.tipCode') })
      return
    }
    const params: any = {}
    if (type === 'email') {
      params.email = account
    } else if (type === 'mobile') {
      params.mobile = account
      params.countryCode = countryCode
    }
    params.captcha = verifyCodeInfo.inputValue
    if (posting) return
    posting = true
    if (codeType === verifyCodeBind || codeType === verifyCodeRegister) {
      memberMobx.bindingAccount(params).then((success: any) => {
        if (success) {
          toast({ message: i18n.t('mkt.giftCard.bindSuccess') })
          resolve()
        }
        posting = false
      }).catch(() => {
        posting = false
      })
    } else if (codeType === verifyCodeMerge) {
      memberMobx.merge(params).then((success: any) => {
        if (success) {
          modalLayer(TipModal, {
            content: type === 'mobile' ? i18n.t('mkt.member.mergeSuccess1', { countryCode: countryCode, mobile: account }) : i18n.t(`mkt.member.mergeSuccess${window.bo === 'cn' ? 3 : 2}`, { email: account }),
            okText: i18n.t('cart.ikonw'),
          }).then(() => {
            resolve()
          })
        }
        posting = false
      }).catch(() => {
        posting = false
      })
    }
  }

  useIonViewWillEnter(() => {
    setVerifyCodeInfo({})
  })
  return (
    <IonModal
      isOpen
      cssClass='ibind-verify'
      enterAnimation={enterAnimation}
      leaveAnimation={leaveAnimation}
    >
      <UseHeader onBack={reject} title={i18n.t('mkt.common.tipCode')}></UseHeader>
      <IonContent className='page-content'>
        <div className='panel'>
          <div className='des'>
            <span className='account-span'>
              {i18n.t('mkt.member.isSendCode', { name: type === 'email' ? account : `+${countryCode} ${account}` })}
            </span>
          </div>
          <div className='body'>
            <VerifyCodeInput autoSend codeType={codeType} account={account} accountType={type} countryCode={countryCode} onChange={(val: any) => setVerifyCodeInfo(val)} />
          </div>
          <div className='footer'>
            <MktButton text={i18n.t('mkt.common.finish')} disabled={!verifyCodeInfo.valid} data-cypid='bindVerifyModal' onClick={handleFinish} />
          </div>
        </div>
      </IonContent>
    </IonModal>
  )
}

export default observer(Verify)
